import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  container: {
    padding: theme.spacing(2),
  },
  titulo: {
    fontSize: theme.typography.h6.fontSize,
  },
  content: {
    padding: theme.spacing(2),
  },
}))

export default useStyles
